import { Tooltip } from 'antd';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Card, Space, StatusField, TextField } from '~/components';
import { useMCC } from '~/hooks';
import { LocationIcon } from '~/img';
import GridLayout from '~/layout/GridLayout';
import { Location } from '~/types';
import buildAddress from '~/utils/buildAddress';

interface Props {
  record: Location;
  onClick: () => void;
}

const LocationCard: FC<Props> = (props) => {
  const { record, onClick } = props;
  const { latitude, longitude } = record.address?.geolocation || {};

  const { t } = useTranslation('locations');
  const { getMCC } = useMCC();

  return (
    <Card
      title={
        <GridLayout xs={24}>
          <TextField label={t('name')}>{record.name}</TextField>
        </GridLayout>
      }
      status={record.status}
      expandable
      onClick={onClick}
    >
      <Space size={16} direction="vertical">
        <StatusField data={record.status} />
        <TextField label={t('address')}>
          {latitude && longitude && (
            <Tooltip title={`${latitude}, ${longitude}`}>
              <LocationIcon className="text-gray" />
            </Tooltip>
          )}{' '}
          {buildAddress(record.address)}
        </TextField>
        <TextField label={t('MCC')}>{getMCC(record.merchantCategoryCode)}</TextField>
      </Space>
    </Card>
  );
};

export default LocationCard;
